module.exports = __webpack_public_path__ + "static/jesus-son-8a357ab5a20e640b8a6ef61914d7b789.jpg";